import {Component, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {TriggerConfiguration} from '@models/adminstration/machine/trigger/trigger-configuration';
import {
  AbstractControl,
  ControlValueAccessor,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
  Validators
} from '@angular/forms';
import {Gateway} from '@models/adminstration/gateway/gateway';
import {SignalEdge} from '@models/adminstration/machine/trigger/signal-edge';

type ChangeCallbackFn<T> = (value: T) => void;
type TouchCallbackFn = () => void;

@Component({
    selector: 'scitis-admin-opc-no-data',
    templateUrl: './opc-no-data.component.html',
    styleUrls: ['./opc-no-data.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => OpcNoDataComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => OpcNoDataComponent),
            multi: true
        }
    ],
    standalone: false
})
export class OpcNoDataComponent implements ControlValueAccessor, Validator, OnInit {

  @Input()
  cloudPlugs: Gateway[] = [];

  @Input()
  isLoadingCloudPlugs = false;

  @Input()
  submitted: boolean = false;

  @Input()
  triggerConfiguration: TriggerConfiguration = new TriggerConfiguration();

  @Input()
  isAdminOrHigher: boolean = false;

  @Output()
  formIsValid: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  updatedTriggerConfiguration: EventEmitter<TriggerConfiguration> = new EventEmitter<TriggerConfiguration>();

  triggerConfigOpcNoDataForm: UntypedFormGroup = this.fb.group({});
  SIGNAL_EDGE_NO_DATA: SignalEdge = SignalEdge.RISING_EDGE;

  constructor(private fb: UntypedFormBuilder) {
  }

// convenience getter for easy access to form fields
  get formControls() {
    return this.triggerConfigOpcNoDataForm.controls;
  }

  ngOnInit(): void {
    this.generateForm();
  }

  validate(control: AbstractControl): ValidationErrors | null {
    if (this.triggerConfigOpcNoDataForm.invalid) {
      return {invalidForm: {valid: false, message: 'OpcNoDataComponent fields are invalid'}};
    }
    return null;
  }

  writeValue(val: any): void {
    if (val) {
      this.triggerConfigOpcNoDataForm.setValue(val, {emitEvent: false});
    }
  }

  registerOnChange(fn: ChangeCallbackFn<object>): void {
    this.triggerConfigOpcNoDataForm.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: TouchCallbackFn): void {
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.triggerConfigOpcNoDataForm.disable();
    } else {
      this.triggerConfigOpcNoDataForm.enable();
    }
  }

  onFocusOut() {
    this.onTriggerConfigUpdated();
  }

  private generateForm(): void {
    this.triggerConfigOpcNoDataForm = this.fb.group({
      cloudPlug: new UntypedFormControl(this.triggerConfiguration.cloudplugId, [Validators.required]),
      signalEdge: new UntypedFormControl(this.SIGNAL_EDGE_NO_DATA)
    });
    this.triggerConfigOpcNoDataForm.controls['signalEdge'].disable();
    this.formIsValid.emit(!this.triggerConfigOpcNoDataForm.invalid);
  }

  private onTriggerConfigUpdated() {
    const triggerConfigUpdated = new TriggerConfiguration();
    triggerConfigUpdated.signalEdge = this.formControls.signalEdge.value;
    triggerConfigUpdated.cloudplugId = this.formControls.cloudPlug.value;
    this.updatedTriggerConfiguration.emit(triggerConfigUpdated);
    this.formIsValid.emit(!this.triggerConfigOpcNoDataForm.invalid);
  }
}
